<template>
  <router-view/>
</template>

<script>
export default {
  name: "BasicLayoutComponent",
}
</script>

<style scoped>

</style>